import { AsyncOperationsModel } from "../../../utility/AsyncOperationsModel";
import { observer } from "mobx-react";
import BaseComponent from "../../../utility/BaseComponent";
import * as React from "react";
import { Tabs, Tab, Paper , TabsContainer, 
    Button, Divider, CircularProgress, ExpansionList, Snackbar, DialogContainer } from "react-md";
import { observable, action, computed, runInAction } from "mobx";
import { IServicesProvider } from "../../../di/IServicesProvider";
import "./static/PushNotifications.scss";
import SendPushNotificationsDialog,
 { SendPushNotificationsDialogModel } from "./SendPushNotificationDialog/SendPushNotificationDialog";
import { IPushNotification, IOrganisation, ICourse } from "../../../model/ModelTypes";
import { isNullOrUndefined } from "util";
import PushNotificationPanel from "../../../component/PushNotificationPanel/PushNotificationPanel";
import { BaseAdminOperations } from "../../../utility/admin/BaseAdminOperations";
import { PushNotificationsOperations } 
from "../../../utility/admin/OrganisationOperations/PushNotificationsOperations/PushNotificationsOperations";
import { IConfig } from "../../../IConfig";
const rootConfig: IConfig = require("Config"); 

export class PushNotificaionsModel extends AsyncOperationsModel {
    @observable mobile: boolean = window.innerWidth < 768;
    @observable services: IServicesProvider;
    @observable sendModel: SendPushNotificationsDialogModel;
    @observable organisation: IOrganisation;
    @observable toasts: string[] = [];
    @observable operations: PushNotificationsOperations;
    @observable deleteDialogVisible: boolean = false;
    @observable onDeleteConfirmed: Function;
    @computed get courses(): ICourse[] {
        return this.organisation.courses;
    } 
    @computed get processedPushNotifications(): IPushNotification[] {
        if (!isNullOrUndefined(this.organisation.processed_push_notifications)) {
        return this.organisation.processed_push_notifications.sort( (a, b) => {
                return (a.processed_time < b.processed_time) ? 1 : ((a.processed_time > b.processed_time) ? -1 : 0);
            });
        }
        return undefined;
    }
    @computed get queuedPushNotifications(): IPushNotification[] {
        if (!isNullOrUndefined(this.organisation.queued_push_notifications)) {
            return this.organisation.queued_push_notifications.sort( (a, b) => {
                    return (a.sending_time < b.sending_time) ? 1 : ((a.sending_time > b.sending_time) ? -1 : 0);
                });
            }
        return undefined;
    }
    constructor(services: IServicesProvider) {
        super();
        this.services = services;
        window.addEventListener('resize', this.updateWidth);
        this.asyncOperationsCount = 0;
    }
    
    @action.bound
    updateWidth() {
        this.mobile = window.innerWidth >= 768 ? false : true ;
    }

    @action.bound
    onCreateClicked(event: React.MouseEvent<HTMLElement>) {
        this.sendModel.setPageX(event.pageX);
        this.sendModel.setPageY(event.pageY);
        this.sendModel.setOrganisation(this.organisation);
        this.sendModel.setDialogVisible(true);

    }

    @action.bound
    // tslint:disable-next-line:no-empty
    onNotificationCreated(notification: IPushNotification, sendLater: boolean) {
        if (!isNullOrUndefined(notification)) {
            if (sendLater) {
                this.setToastMessage("Notification Created");
            } else {
                this.setToastMessage("Notification Sent");
            }
        }
        this.sendModel.sendDisabled = false;
        this.sendModel.setDialogVisible(false);
    }
    @action.bound
    setOperations(operations: PushNotificationsOperations) {
        this.operations = operations;
        operations.observeOrganisationChanges()
        .subscribe(this.setOrganisation, (error) => this.setErrorMessages(["Error Fetching Organisation Details"]));
        this.sendModel =  new SendPushNotificationsDialogModel(operations);
        this.sendModel.onComplete = this.onNotificationCreated;
        this.sendModel.setUser(this.services.getUser());

    }

    @action.bound
    setOrganisation(organisation: IOrganisation) {
        this.organisation = organisation;
    }

    @action.bound
    prepare() {
        this.incrementAsyncOperations();
        BaseAdminOperations
        .build<PushNotificationsOperations>(
            PushNotificationsOperations,
            this.services.getDataStore(),
            this.services.getAdminServicesProvider()
            .getUsersControls()
            .getOperations()
            .getApi(),
            this.services.getUser().organisation,
            this.services.getUser(),
            rootConfig
        ).subscribe(
            recievedOpearations => {
                    runInAction( () => {
                        this.setOperations(recievedOpearations);
                    });
            },
            error => {
                this.setErrorMessages(["Something Went Wrong"]);
            }  
        );
    }

    @action.bound
    onDeleteClicked(notification: IPushNotification) {
        this.onDeleteConfirmed = () => {
            runInAction( () => {
                this.deleteDialogVisible = false;
                this.operations
                    .deleteQueuedNotification(notification)
                    .subscribe(success =>  this.setToastMessage("Notification Deleted"),
                               error => this.setToastMessage(error.toString()));
            } );
        };
        this.deleteDialogVisible = true;
    }
    @action.bound
    setToastMessage(message: string) {
        this.toasts = [message];
    }
    @action.bound
    onToastDismiss() {
        this.toasts = [];
    }

}

@observer class PushNotifications extends BaseComponent<{model: PushNotificaionsModel}, {}> {

    notificationButton = () => {
        return ( 
        <Button 
                raised={true} 
                secondary={true} 
                onClick={this.props.model.onCreateClicked}
        >Create Notification 
        </Button>
        );
    }
    noNotificationsMessage = () => {
        return (
            <div>
                <p>Send your first push notification</p>
                {this.notificationButton()}
            </div>
        );
    }
    render() {
        return (
            <div className="root">
                {
                    isNullOrUndefined(this.props.model.organisation) &&
                    <CircularProgress centered={true} id="progress" />
                }
                {
                    !isNullOrUndefined(this.props.model.organisation) &&
                    <TabsContainer className="PushNotificationTabsContainer" panelClassName="md-grid" colored={true}>
                    <Tabs tabId="simple-tab" mobile={this.props.model.mobile}>
                    <Tab className="PushNotificationTab" label="Processed Notifications">
                        <Paper zDepth={0} className="PushNotificationCardItem">
                            <div className="PushNotificationsCreateContainer">
                                {this.notificationButton()}
                            </div>
                            <Divider />
                            <div className="PushNotificationsTabViewContainer">
                                {
                                    (isNullOrUndefined(this.props.model.processedPushNotifications) ||
                                    this.props.model.processedPushNotifications.length === 0 ) &&
                                    this.noNotificationsMessage() 
                                }
                                {
                                    (!isNullOrUndefined(this.props.model.processedPushNotifications) &&
                                    this.props.model.processedPushNotifications.length !== 0 ) &&
                                    <ExpansionList>
                                        {
                                            this.props.model.processedPushNotifications.map(
                                                (notification, index) => {
                                                    return (
                                                    <PushNotificationPanel 
                                                        
                                                        key={`processed_${index}`}
                                                        notification={notification}
                                                        userOrganisationCode={this.props.model.organisation.code}
                                                        // tslint:disable-next-line:no-console
                                                        onDeleteClicked={this.props.model.onDeleteClicked}
                                                        isProcessed={true}
                                                    />
                                                            );
                                                }
                                            )
                                        }
                                    
                                    </ExpansionList>
                                }
                            </div>
                        </Paper>
                    </Tab>
                    <Tab className="PushNotificationTab" label="Queued Notifications">
                        <Paper zDepth={0}className="PushNotificationCardItem">
                            <div className="PushNotificationsCreateContainer">
                                {this.notificationButton()}
                            </div>
                            <Divider />
                            <div className="PushNotificationsTabViewContainer">
                                {
                                    (isNullOrUndefined(this.props.model.queuedPushNotifications) ||
                                    this.props.model.queuedPushNotifications.length === 0 ) &&
                                    this.noNotificationsMessage() 
                                }
                                {
                                    (!isNullOrUndefined(this.props.model.queuedPushNotifications) &&
                                    this.props.model.queuedPushNotifications.length !== 0 ) &&
                                    <ExpansionList>
                                        {
                                            this.props.model.queuedPushNotifications.map(
                                                (notification, index) => {
                                                    return (
                                                    <PushNotificationPanel 
                                                        key={`queued_${index}`}
                                                        notification={notification}
                                                        userOrganisationCode={this.props.model.organisation.code}

                                                        // tslint:disable-next-line:no-console
                                                        onDeleteClicked={this.props.model.onDeleteClicked}
                                                        isProcessed={false}
                                                    />
                                                            );
                                                }
                                            )
                                        }
                                    
                                    </ExpansionList>
                                }
                            </div>
                        </Paper>
                        
                    </Tab>

                    </Tabs>
                    </TabsContainer>

                }
                {
                    !isNullOrUndefined(this.props.model.organisation) &&
                    <SendPushNotificationsDialog model={this.props.model.sendModel}/>
                }
                <DialogContainer
                        id="simple-action-dialog"
                        visible={this.props.model.deleteDialogVisible}
                        onHide={() => this.props.model.deleteDialogVisible = false}
                        title="Confrim Delete"
                        actions={[
                            <Button
                                key="cancel"
                                flat={true}
                                onClick={() => this.props.model.deleteDialogVisible = false}
                                className='CancelDelete'
                            >
                            Cancel
                            </Button>,
                            <Button
                                key="delete"
                                flat={true}
                                onClick={
                                    () => this.props.model.onDeleteConfirmed()
                                }
                                className='ConfirmDelete'
                            >
                            Delete
                            </Button>

                        ]}
                        className='DeleteConfirmation'
                >
                    <p> Are you sure you want to delete this item?</p>
                        
                </DialogContainer>
                <Snackbar
                    id="snackbar"
                    toasts={this.props.model.toasts.map(item => {
                        return {
                            text: item
                        };
                    })}
                    autohide={true}
                    onDismiss={this.props.model.onToastDismiss}
                />
            </div>
                    
        );
    }
}
export default PushNotifications;


// WEBPACK FOOTER //
// ./src/view/Admin/PushNotifications/PushNotifications.tsx